import React, { useEffect, useState } from "react";
import { RefreshCw } from "lucide-react";
import { api } from "@/lib/api";
import { useI18n } from "@/context/I18nContext";
import { ProductCard } from "@/components/ProductCard";

export default function UsedShop() {
  const { t } = useI18n();
  const [data, setData] = useState({ products: [], total: 0 });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/products", { params: { used: true, limit: 96, sort: "featured" } })
      .then((r) => setData(r.data)).finally(() => setLoading(false));
  }, []);

  return (
    <div className="mx-auto max-w-7xl px-4 py-10">
      <div className="mb-10 flex items-start gap-4">
        <RefreshCw className="text-brand-red mt-1 shrink-0" size={30} />
        <div>
          <h1 className="font-heading text-4xl sm:text-5xl font-extrabold tracking-tight" data-testid="used-title">{t("used.title")}</h1>
          <p className="text-gray-500 mt-2 max-w-2xl">{t("used.subtitle")}</p>
        </div>
      </div>

      {loading ? (
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
          {Array(8).fill(0).map((_, i) => <div key={i} className="border border-gray-200 bg-white aspect-[3/4] animate-pulse" />)}
        </div>
      ) : data.products.length === 0 ? (
        <div className="py-24 text-center text-gray-500" data-testid="used-none">{t("used.none")}</div>
      ) : (
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4" data-testid="used-grid">
          {data.products.map((p, i) => <ProductCard key={p.id} product={p} index={i} />)}
        </div>
      )}
    </div>
  );
}
